function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import Imgix from 'react-imgix';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import getStringFormatter from '@signal/utils/getStringFormatter';
import { SORT_ASCENDING, SORT_DESCENDING } from './constants';
import { TableWrapper, StyledTable, TableHead, StyledRow, TableCell } from './styles';
import { stableSort, getSorting, rowsPerPageOptions } from './sorting';
import capitalize from 'lodash/capitalize';
import isValidNumber from '@signal/utils/isValidNumber';
export * from './constants';

var SortableTable = function SortableTable(_ref) {
  var rows = _ref.rows,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection,
      _ref$rowsPerPage = _ref.rowsPerPage,
      rowsPerPageConstant = _ref$rowsPerPage === void 0 ? 5 : _ref$rowsPerPage,
      _ref$getRowKey = _ref.getRowKey,
      getRowKey = _ref$getRowKey === void 0 ? function (rows, i) {
    return i;
  } : _ref$getRowKey,
      style = _ref.style,
      className = _ref.className;
  var firstRowValues = get(rows, [0, 'rows'], []); // an array of the data keys

  var rawKeys = firstRowValues.map(function (_ref2) {
    var label = _ref2.label;
    return label;
  }); // establish state hooks

  var _useState = useState(sortDirection || SORT_ASCENDING),
      _useState2 = _slicedToArray(_useState, 2),
      order = _useState2[0],
      setOrder = _useState2[1];

  var _useState3 = useState(sortBy || rawKeys[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      orderBy = _useState4[0],
      setOrderBy = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState(rowsPerPageConstant),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1]; // limit the max pagination according to data set


  var paginationOptions = rowsPerPageOptions(rows.length, rowsPerPageConstant);

  function handleRequestSort(event, property) {
    var newOrderBy = property;
    var newOrder = SORT_DESCENDING;

    if (orderBy === newOrderBy && order === SORT_DESCENDING) {
      newOrder = SORT_ASCENDING;
    }

    setOrderBy(newOrderBy);
    setOrder(newOrder);
  }

  function handleChangePage(event, page) {
    setPage(page);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(event.target.value);
  }

  var isNumeric = function isNumeric(format) {
    return capitalize(format) !== 'String';
  }; // create the column labels


  var columnLabels = firstRowValues.map(function (_ref3, i) {
    var label = _ref3.label,
        format = _ref3.format;
    return {
      id: label,
      numeric: isNumeric(format),
      isImage: format.toLowerCase() === 'image',
      label: label,
      disablePadding: i === 0
    };
  });
  var sortedPageRows = stableSort(rows, getSorting(order, orderBy, function (arr, key) {
    var match = find(arr.rows, function (o) {
      return o.label === key;
    });

    if (match) {
      if (!isValidNumber(match.value)) return -1;
      if (!isNumeric(match.format)) return match.value;
      return parseFloat(match.value);
    }

    return -1;
  })).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TableWrapper, {
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(StyledTable, {
    "aria-labelledby": "tableTitle"
  }, /*#__PURE__*/React.createElement(TableHead, {
    order: order,
    orderBy: orderBy,
    onRequestSort: handleRequestSort,
    rowCount: rows.length,
    rows: columnLabels
  }), /*#__PURE__*/React.createElement(TableBody, null, sortedPageRows.map(function (_ref4, i) {
    var meta = _ref4.meta,
        rows = _ref4.rows;
    return /*#__PURE__*/React.createElement(StyledRow, {
      key: getRowKey(rows, i),
      highlight: get(meta, 'highlight')
    }, rows.map(function (row, i) {
      var Component = row.component,
          componentProps = row.componentProps,
          rest = _objectWithoutProperties(row, ["component", "componentProps"]);

      var format = row.format,
          value = row.value;
      var isImage = format.toLowerCase() === 'image';
      var align = 'right';
      if (!isNumeric(format) || i === 0) align = 'left';
      var cellChild = null;

      if (isImage) {
        cellChild = /*#__PURE__*/React.createElement(Imgix, {
          src: value || '',
          width: 30,
          height: 30,
          imgixParams: {
            fit: 'clip'
          }
        });
      } else if (Component) {
        cellChild = /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, componentProps));
      } else {
        cellChild = getStringFormatter(format)(value);
      }

      return /*#__PURE__*/React.createElement(TableCell, {
        key: i,
        align: align,
        size: isImage ? 'small' : 'medium',
        style: {
          width: !isNumeric(format) ? '100%' : null
        }
      }, cellChild);
    }));
  })))), /*#__PURE__*/React.createElement(TablePagination, {
    rowsPerPageOptions: paginationOptions,
    component: "div",
    count: rows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    backIconButtonProps: {
      'aria-label': 'Previous Page'
    },
    nextIconButtonProps: {
      'aria-label': 'Next Page'
    },
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
};

SortableTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortBy: PropTypes.string,
  rowsPerPage: PropTypes.number
};
export default SortableTable;